import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { CronFlavor, CronOptions } from '@sarasanalytics-com/cron-editor/lib/CronOptions';


@Component({
  selector: 'app-cron-plugin',
  templateUrl: './cron-plugin.component.html',
  styleUrls: ['./cron-plugin.component.scss']
})
export class CronPluginComponent implements OnInit {
  @Input() cronFlavor: CronFlavor = 'standard';
  public txtCron!: string;
  showExpression: boolean = false;
  public cronExpression = "0/1 * 1/1 * *"; //for standard'0/1 * 1/1 * *'; //for Quartz"0 0 0 1/1 * ?";
  public cronForm: any;
  public show = false;
  public cronOptions: CronOptions;

  public constructor(public formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.cronOptions = {
      formInputClass: 'cron-editor-input',
      formSelectClass: 'cron-editor-select',
      formRadioClass: 'cron-editor-radio',
      formCheckboxClass: 'cron-editor-checkbox',
      defaultTime: '00:00:00',
      hideMinutesTab: false,
      hideHourlyTab: false,
      hideDailyTab: false,
      hideWeeklyTab: false,
      hideMonthlyTab: false,
      hideYearlyTab: false,
      hideAdvancedTab: true,
      hideSpecificWeekDayTab: false,
      hideSpecificMonthWeekTab: false,
      use24HourTime: true,
      hideSeconds: false,
      cronFlavor: this.cronFlavor,
    };
    this.cronExpression = this.cronFlavor === 'quartz' ? '0 0/0 * 1/1 * ? *' : this.cronExpression;
    this.initReactiveModel();
    this.cronForm = new UntypedFormControl(this.cronExpression);
    this.show = true;

  }

  public initReactiveModel() {
    this.cronForm = this.formBuilder.group({
      cronExpression: new UntypedFormControl('0/1 * 1/1 * *'),
    })
  }

  public refresh() {
    this.cronForm.patchValue('0 12 * * MON-FRI');

    this.cronExpression = this.txtCron;
    this.cronForm.patchValue(this.cronExpression);
  }

  public getValue() {
    console.log(this.cronForm.value);
  }

  public reload() {
    this.cronExpression = this.txtCron;
    this.cronForm.patchValue(this.cronExpression);
  }

  onExpressionCopy(isCopied: boolean){
    console.log(isCopied)
  }

}
